import { v4 as uuidv4 } from 'uuid';

// Whole-browser session id, shared across tabs. Stored in localStorage.
//  Rolls a fresh id after an idle gap.
export const SESSION_KEY = 'pe_tracking_session_id';
export const SESSION_ACTIVITY_KEY = 'pe_tracking_session_last_activity';
export const IDLE_MS = 30 * 60 * 1000;

const readLs = (key: string): string | null => {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

const writeLs = (key: string, value: string): void => {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* tracking must never throw */
  }
};

/**
 * Returns the current session id, minting a new one if none exists or the
 * previous session has been idle longer than IDLE_MS. Always refreshes the
 * last-activity timestamp.
 */
export const getSessionId = (): string => {
  let id = readLs(SESSION_KEY);
  const lastActivityRaw = readLs(SESSION_ACTIVITY_KEY);
  const lastActivity = lastActivityRaw ? Number(lastActivityRaw) : 0;
  const now = Date.now();

  const isIdleExpired = !lastActivity || now - lastActivity > IDLE_MS;
  if (!id || isIdleExpired) {
    id = uuidv4();
    writeLs(SESSION_KEY, id);
  }

  writeLs(SESSION_ACTIVITY_KEY, String(now));
  return id;
};

/** Non-minting read of the current session id; null if none exists yet. */
export const peekSessionId = (): string | null => readLs(SESSION_KEY);
